module.exports = __webpack_public_path__ + "static/media/slider-next-icon.acea7169.svg";